// src/utils/apiFetch.js
import { ensureVisitorId } from '../utils/wishlistStorage' // już masz to u siebie
const API_BASE = process.env.GATSBY_API_URL || '/api'

export default function apiFetch(path, opts = {}) {
  const headers = {
    'Accept': 'application/json',
    ...(opts.body ? { 'Content-Type': 'application/json' } : {}),
    'x-visitor-id': ensureVisitorId(),
    ...(opts.headers || {}),
  }
  const final = {
    ...opts,
    headers,
    credentials: 'include',
    ...(opts.body && typeof opts.body !== 'string'
      ? { body: JSON.stringify(opts.body) }
      : {}),
  }
  return fetch(API_BASE + path, final)
}
